import { call, put } from 'redux-saga/effects';
import { photoCaptureIntelligentErrorLogFailureAction, photoCaptureIntelligentErrorLogSuccessAction } from '../actions';
import { IntelligentPhotoCaptureErrorLogService } from '../services';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
export function* intelligentPhotoCaptureErrorLogSaga(action) {
    try {
        const errorLogService = new IntelligentPhotoCaptureErrorLogService();
        yield call([errorLogService, errorLogService.errorLog], action.payload.companyCode, action.payload.request, action.payload.instanceReferenceId);
        yield put(photoCaptureIntelligentErrorLogSuccessAction());
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureIntelligentErrorLogFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureErrorLogSaga.js.map